<template>
  <div class="simple_item">
    <el-form-item :label="item.label" :prop="`${tableName}.${groupName},${item.key}`" class="simple-readonly-item">
        <span style="margin-left: 60px; color: #111;" class ="readonly-text">{{ displayValue }}</span>
    </el-form-item>
  </div>
</template>

<script>
export default ({
    name: 'TwProcessGroupListItemSimple',
    props: {
        item: Object,
        tableName: String,
        groupName: String,
        value: Object,
    },
    computed: {
        displayValue() {
            const val = this.value?.[this.tableName]?.[this.groupName]?.[this.item.key];
            if(val === null || val === undefined || val === '') return '';
            if(this.item.inputType === 'date' && typeof val === 'string') {
              return val.slice(0, 10);
            }
            return val;
        },
    },
});
</script>

<style lang="scss">
  .simple_item {
    .el-form-item__label {
      width: 120px;
      text-align: left;
    }
  }
  .simple-readonly-item .readonly-text {
    user-select: text;
    cursor: text;
  }
</style>
